import { useAuth } from "@/hooks";

interface Props {
  children: React.ReactNode;
}

export function AuthenticatedProvider({ children }: Readonly<Props>) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
